module.exports = __webpack_public_path__ + "static/media/illustration-refresh.9c9f47d0.jpg";